/**
 * Structure of the privacy policy ("Personvernerklæring"), from Personvern_Zuprize_081026.docx.
 *
 * Generated from the client's document; every id is a translation key whose
 * Norwegian text is the document's, verbatim. Rendered by
 * _marketingPage/LegalDocument.js. To change the wording, change the
 * translation, not this file; to change the structure, regenerate it.
 */
const privacyPolicyDocument = {
  header: {
    eyebrow: 'PrivacyPolicyPage.heroEyebrow',
    heading: 'PrivacyPolicyPage.heroHeading',
    lastUpdated: 'PrivacyPolicyPage.lastUpdated',
    lede: [
      'PrivacyPolicyPage.heroLede1',
      'PrivacyPolicyPage.heroLede2'
    ]
  },
  sections: [
    {
      id: 'behandlingsansvarlig',
      heading: 'PrivacyPolicyPage.s1Heading',
      blocks: [
        {
          type: 'p',
          id: 'PrivacyPolicyPage.s1b1'
        },
        {
          type: 'lines',
          lines: [
            'PrivacyPolicyPage.s1b2l1',
            'PrivacyPolicyPage.s1b2l2',
            'PrivacyPolicyPage.s1b2l3',
            'PrivacyPolicyPage.s1b2l4'
          ]
        },
        {
          type: 'p',
          id: 'PrivacyPolicyPage.s1b3'
        }
      ]
    },
    {
      id: 'hvilke-personopplysninger-vi-behandler',
      heading: 'PrivacyPolicyPage.s2Heading',
      blocks: [
        {
          type: 'p',
          id: 'PrivacyPolicyPage.s2b1'
        },
        {
          type: 'sub',
          id: 'PrivacyPolicyPage.s2b2'
        },
        {
          type: 'list',
          items: [
            'PrivacyPolicyPage.s2b3i1',
            'PrivacyPolicyPage.s2b3i2',
            'PrivacyPolicyPage.s2b3i3',
            'PrivacyPolicyPage.s2b3i4',
            'PrivacyPolicyPage.s2b3i5',
            'PrivacyPolicyPage.s2b3i6',
            'PrivacyPolicyPage.s2b3i7',
            'PrivacyPolicyPage.s2b3i8',
            'PrivacyPolicyPage.s2b3i9',
            'PrivacyPolicyPage.s2b3i10'
          ]
        },
        {
          type: 'sub',
          id: 'PrivacyPolicyPage.s2b4'
        },
        {
          type: 'list',
          items: [
            'PrivacyPolicyPage.s2b5i1',
            'PrivacyPolicyPage.s2b5i2',
            'PrivacyPolicyPage.s2b5i3',
            'PrivacyPolicyPage.s2b5i4',
            'PrivacyPolicyPage.s2b5i5',
            'PrivacyPolicyPage.s2b5i6'
          ]
        },
        {
          type: 'sub',
          id: 'PrivacyPolicyPage.s2b6'
        },
        {
          type: 'list',
          items: [
            'PrivacyPolicyPage.s2b7i1',
            'PrivacyPolicyPage.s2b7i2',
            'PrivacyPolicyPage.s2b7i3'
          ]
        }
      ]
    },
    {
      id: 'formal-og-rettslig-grunnlag',
      heading: 'PrivacyPolicyPage.s3Heading',
      blocks: [
        {
          type: 'p',
          id: 'PrivacyPolicyPage.s3b1'
        },
        {
          type: 'table',
          head: [
            'PrivacyPolicyPage.s3b2h1',
            'PrivacyPolicyPage.s3b2h2'
          ],
          rows: [
            [
              'PrivacyPolicyPage.s3b2r1c1',
              'PrivacyPolicyPage.s3b2r1c2'
            ],
            [
              'PrivacyPolicyPage.s3b2r2c1',
              'PrivacyPolicyPage.s3b2r2c2'
            ],
            [
              'PrivacyPolicyPage.s3b2r3c1',
              'PrivacyPolicyPage.s3b2r3c2'
            ],
            [
              'PrivacyPolicyPage.s3b2r4c1',
              'PrivacyPolicyPage.s3b2r4c2'
            ],
            [
              'PrivacyPolicyPage.s3b2r5c1',
              'PrivacyPolicyPage.s3b2r5c2'
            ],
            [
              'PrivacyPolicyPage.s3b2r6c1',
              'PrivacyPolicyPage.s3b2r6c2'
            ],
            [
              'PrivacyPolicyPage.s3b2r7c1',
              'PrivacyPolicyPage.s3b2r7c2'
            ],
            [
              'PrivacyPolicyPage.s3b2r8c1',
              'PrivacyPolicyPage.s3b2r8c2'
            ],
            [
              'PrivacyPolicyPage.s3b2r9c1',
              'PrivacyPolicyPage.s3b2r9c2'
            ],
            [
              'PrivacyPolicyPage.s3b2r10c1',
              'PrivacyPolicyPage.s3b2r10c2'
            ],
            [
              'PrivacyPolicyPage.s3b2r11c1',
              'PrivacyPolicyPage.s3b2r11c2'
            ],
            [
              'PrivacyPolicyPage.s3b2r12c1',
              'PrivacyPolicyPage.s3b2r12c2'
            ],
            [
              'PrivacyPolicyPage.s3b2r13c1',
              'PrivacyPolicyPage.s3b2r13c2'
            ],
            [
              'PrivacyPolicyPage.s3b2r14c1',
              'PrivacyPolicyPage.s3b2r14c2'
            ],
            [
              'PrivacyPolicyPage.s3b2r15c1',
              'PrivacyPolicyPage.s3b2r15c2'
            ]
          ]
        },
        {
          type: 'p',
          id: 'PrivacyPolicyPage.s3b3'
        }
      ]
    },
    {
      id: 'hvem-vi-deler-personopplysninger-med',
      heading: 'PrivacyPolicyPage.s4Heading',
      blocks: [
        {
          type: 'p',
          id: 'PrivacyPolicyPage.s4b1'
        },
        {
          type: 'sub',
          id: 'PrivacyPolicyPage.s4b2'
        },
        {
          type: 'p',
          id: 'PrivacyPolicyPage.s4b3'
        },
        {
          type: 'p',
          id: 'PrivacyPolicyPage.s4b4'
        },
        {
          type: 'sub',
          id: 'PrivacyPolicyPage.s4b5'
        },
        {
          type: 'p',
          id: 'PrivacyPolicyPage.s4b6'
        },
        {
          type: 'sub',
          id: 'PrivacyPolicyPage.s4b7'
        },
        {
          type: 'p',
          id: 'PrivacyPolicyPage.s4b8'
        },
        {
          type: 'table',
          head: [
            'PrivacyPolicyPage.s4b9h1',
            'PrivacyPolicyPage.s4b9h2'
          ],
          rows: [
            [
              'PrivacyPolicyPage.s4b9r1c1',
              'PrivacyPolicyPage.s4b9r1c2'
            ],
            [
              'PrivacyPolicyPage.s4b9r2c1',
              'PrivacyPolicyPage.s4b9r2c2'
            ],
            [
              'PrivacyPolicyPage.s4b9r3c1',
              'PrivacyPolicyPage.s4b9r3c2'
            ],
            [
              'PrivacyPolicyPage.s4b9r4c1',
              'PrivacyPolicyPage.s4b9r4c2'
            ],
            [
              'PrivacyPolicyPage.s4b9r5c1',
              'PrivacyPolicyPage.s4b9r5c2'
            ],
            [
              'PrivacyPolicyPage.s4b9r6c1',
              'PrivacyPolicyPage.s4b9r6c2'
            ],
            [
              'PrivacyPolicyPage.s4b9r7c1',
              'PrivacyPolicyPage.s4b9r7c2'
            ],
            [
              'PrivacyPolicyPage.s4b9r8c1',
              'PrivacyPolicyPage.s4b9r8c2'
            ],
            [
              'PrivacyPolicyPage.s4b9r9c1',
              'PrivacyPolicyPage.s4b9r9c2'
            ]
          ]
        },
        {
          type: 'p',
          id: 'PrivacyPolicyPage.s4b10'
        },
        {
          type: 'p',
          id: 'PrivacyPolicyPage.s4b11'
        },
        {
          type: 'sub',
          id: 'PrivacyPolicyPage.s4b12'
        },
        {
          type: 'p',
          id: 'PrivacyPolicyPage.s4b13'
        }
      ]
    },
    {
      id: 'hvor-lenge-vi-lagrer-personopplysninger',
      heading: 'PrivacyPolicyPage.s5Heading',
      blocks: [
        {
          type: 'p',
          id: 'PrivacyPolicyPage.s5b1'
        },
        {
          type: 'list',
          items: [
            'PrivacyPolicyPage.s5b2i1',
            'PrivacyPolicyPage.s5b2i2',
            'PrivacyPolicyPage.s5b2i3',
            'PrivacyPolicyPage.s5b2i4',
            'PrivacyPolicyPage.s5b2i5',
            'PrivacyPolicyPage.s5b2i6'
          ]
        }
      ]
    },
    {
      id: 'dine-rettigheter',
      heading: 'PrivacyPolicyPage.s6Heading',
      blocks: [
        {
          type: 'p',
          id: 'PrivacyPolicyPage.s6b1'
        },
        {
          type: 'sub',
          id: 'PrivacyPolicyPage.s6b2'
        },
        {
          type: 'p',
          id: 'PrivacyPolicyPage.s6b3'
        },
        {
          type: 'sub',
          id: 'PrivacyPolicyPage.s6b4'
        },
        {
          type: 'p',
          id: 'PrivacyPolicyPage.s6b5'
        },
        {
          type: 'sub',
          id: 'PrivacyPolicyPage.s6b6'
        },
        {
          type: 'p',
          id: 'PrivacyPolicyPage.s6b7'
        },
        {
          type: 'sub',
          id: 'PrivacyPolicyPage.s6b8'
        },
        {
          type: 'p',
          id: 'PrivacyPolicyPage.s6b9'
        },
        {
          type: 'sub',
          id: 'PrivacyPolicyPage.s6b10'
        },
        {
          type: 'p',
          id: 'PrivacyPolicyPage.s6b11'
        },
        {
          type: 'sub',
          id: 'PrivacyPolicyPage.s6b12'
        },
        {
          type: 'p',
          id: 'PrivacyPolicyPage.s6b13'
        },
        {
          type: 'sub',
          id: 'PrivacyPolicyPage.s6b14'
        },
        {
          type: 'p',
          id: 'PrivacyPolicyPage.s6b15'
        },
        {
          type: 'sub',
          id: 'PrivacyPolicyPage.s6b16'
        },
        {
          type: 'p',
          id: 'PrivacyPolicyPage.s6b17'
        }
      ]
    },
    {
      id: 'sikkerhet',
      heading: 'PrivacyPolicyPage.s7Heading',
      blocks: [
        {
          type: 'p',
          id: 'PrivacyPolicyPage.s7b1'
        },
        {
          type: 'list',
          items: [
            'PrivacyPolicyPage.s7b2i1',
            'PrivacyPolicyPage.s7b2i2',
            'PrivacyPolicyPage.s7b2i3',
            'PrivacyPolicyPage.s7b2i4',
            'PrivacyPolicyPage.s7b2i5'
          ]
        },
        {
          type: 'p',
          id: 'PrivacyPolicyPage.s7b3'
        },
        {
          type: 'sub',
          id: 'PrivacyPolicyPage.s7b4'
        },
        {
          type: 'p',
          id: 'PrivacyPolicyPage.s7b5'
        },
        {
          type: 'p',
          id: 'PrivacyPolicyPage.s7b6'
        },
        {
          type: 'p',
          id: 'PrivacyPolicyPage.s7b7'
        }
      ]
    },
    {
      id: 'personer-under-18-ar',
      heading: 'PrivacyPolicyPage.s8Heading',
      blocks: [
        {
          type: 'p',
          id: 'PrivacyPolicyPage.s8b1'
        }
      ]
    },
    {
      id: 'endringer-i-personvernerklaeringen',
      heading: 'PrivacyPolicyPage.s9Heading',
      blocks: [
        {
          type: 'p',
          id: 'PrivacyPolicyPage.s9b1'
        },
        {
          type: 'p',
          id: 'PrivacyPolicyPage.s9b2'
        }
      ]
    },
    {
      id: 'kontakt',
      heading: 'PrivacyPolicyPage.s10Heading',
      blocks: [
        {
          type: 'p',
          id: 'PrivacyPolicyPage.s10b1'
        },
        {
          type: 'lines',
          lines: [
            'PrivacyPolicyPage.s10b2l1',
            'PrivacyPolicyPage.s10b2l2',
            'PrivacyPolicyPage.s10b2l3'
          ]
        }
      ]
    }
  ]
};

export default privacyPolicyDocument;
